module.exports = __webpack_public_path__ + "img/slika44.3ff3a3e1.jpg";